import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w-full relative font-montserrat" }
const _hoisted_2 = {
  key: 0,
  class: "bg-red-600 border border-red-600 my-[10px] text-white text-center fixed md:top-[80px] top-[60px] shadow-lg left-[50%] translate-x-[-50%] font-bold flex justify-center items-center z-30 rounded-[5px] max-w-[450px] w-[90%] p-[20px]"
}
const _hoisted_3 = { class: "relative pt-[70px] w-full mb-[50px]" }
const _hoisted_4 = { class: "flex justify-end items-center" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "w-full relative py-[10px] flex justify-center items-center" }
const _hoisted_16 = { class: "w-[75px] h-[50px] relative overflow-hidden flex justify-center items-center" }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "w-full py-[20px] flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center font-bold text-sm" }, "© 2023 Cotonou Cadjehoun, Tous droits réservés.")
], -1)

import headerComponent from '@/components/headerComponentAdmin.vue';
import { ref, onMounted } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';
import { QuillEditor, Quill } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import axiosInstance from '@/plugins/axios';

import BlotFormatter from "quill-blot-formatter/dist/BlotFormatter";



export default /*#__PURE__*/_defineComponent({
  __name: 'AddAnArticle',
  setup(__props) {

const modules = {
  name: "blotFormatter",
  module: BlotFormatter,
  options: {/* options */},
}

const loading = ref(false);
const loading1 = ref(false);
const loading2 = ref(false);
const router = useRouter();
const pageTitle = ref('Add an article');

const content = ref('');
const title = ref('');
const publishedArticles = ref([]);
const source = ref('');
const selectedImage = ref(null);
const errorMessage = ref("");
const viewImage = ref('')

const isUpdateRoute = router.currentRoute.value.path.includes("/AddAnArticle/") && router.currentRoute.value.params.id;
const isNewRoute = router.currentRoute.value.path === "/AddAnArticle";



onMounted(() => {
    document.title = pageTitle.value;
});

const handleImageChange = (event: any) => {
  selectedImage.value = event.target.files[0];
};

const updateContent = (value: any) => {
  content.value = value;
};

let userId = ref(null);

const saveArticle = async () => {
  try {
    loading1.value = true;
    const token = localStorage.getItem('token');
    if (!token) return;


    const userResponse = await axiosInstance.get('/auth/users/me/', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    userId.value = userResponse.data.id;

    const formData = new FormData();
    formData.append('title', title.value);
    formData.append('content', content.value);
    if (selectedImage.value) {
      formData.append('image', selectedImage.value);
    };
    formData.append('source', source.value);
    if (userId.value) {
      formData.append('author_id', userId.value);
    };

    const response = await axiosInstance.post('/articles/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    });

    let newArticleId ;

    if (response.status === 200 || response.status === 201 || response.status === 204) {
      const newArticleId = response.data.id; 
    }
    router.push('/ListeOfArticle');
  } catch (error) {
    errorMessage.value = 'Erreur lors de la création ou du sauvegarde de l\'article';
    hideErrorMessageAfterDelay();
  } finally {
    loading1.value = false;
  }
};
const publishArticle = async () => {
  try {
    loading.value = true;
    const token = localStorage.getItem('token');
    if (!token) return;


    const userResponse = await axiosInstance.get('/auth/users/me/', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    userId.value = userResponse.data.id;

    const formData = new FormData();
    formData.append('title', title.value);
    formData.append('content', content.value);
    if (selectedImage.value) {
      formData.append('image', selectedImage.value);
    };
    formData.append('source', source.value);
    if (userId.value) {
      formData.append('author_id', userId.value);
    };

    const response = await axiosInstance.post('/articles/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    });

    let lastArticleId ;

    if (response.status === 200 || response.status === 201 || response.status === 204) {
      try {
        const response = await axiosInstance.get('/articles/');
        if (response.status === 200 || response.status === 201 || response.status === 204) {
          const articles = response.data.results;
          if (articles.length > 0) {
            const lastArticle = articles[0];
            lastArticleId = lastArticle.id;
          }
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des articles', error);
      }
      const newArticleId = lastArticleId;

      const publishResponse = await axiosInstance.put(`/articles/${newArticleId}/publish/`, null, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (publishResponse.status === 204 || publishResponse.status === 201 || publishResponse.status === 2040 ) {
        title.value = '';
        content.value = '';
        source.value = '';
        selectedImage.value = null;
      } else {
        console.error('Erreur lors de la publication de l\'article');
      }
    }
    router.push('/ListeOfArticle');
  } catch (error) {
    errorMessage.value = 'Erreur lors de la création ou de la publication de l\'article';
    hideErrorMessageAfterDelay();
  } finally {
    loading.value = false;
  }
};
const hideErrorMessageAfterDelay = () => {
  setTimeout(() => {
    errorMessage.value = ''; 
  }, 5000);
};

onMounted(() => {
  document.title = pageTitle.value;
  const articleId = router.currentRoute.value.params.id;

  if (articleId) {
    loadArticleDetails(articleId);
    pageTitle.value = 'Update an article';
  }
});
const selectedArticle = ref(null);

const loadArticleDetails = async (id: number) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return;

    const response = await axiosInstance.get(`/articles/${id}/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const article = response.data;
    selectedArticle.value = article;
    title.value = article.title;
    content.value = article.content;
    source.value = article.source;
    viewImage.value = article.image;
  } catch (error) {
    errorMessage.value = 'Erreur lors du chargement des détails de l\'article';
    hideErrorMessageAfterDelay();
  }
};

const updateArticle = async () => {
  try {
    loading2.value = true;
    const token = localStorage.getItem('token');
    if (!token) return;

    const userResponse = await axiosInstance.get('/auth/users/me/', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    userId.value = userResponse.data.id;

    const response = await axiosInstance.patch(`/articles/${selectedArticle.value.id}/`, {
      title: title.value,
      content: content.value,
      source: source.value,
      image: selectedImage.value,
      author: userId.value
    }, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201 || response.status === 204) {
      title.value = '';
      content.value = '';
      source.value = '';
      selectedImage.value = null;
      router.push('/ListeOfArticle');
    } else {
    }
  } catch (error) {
    errorMessage.value = 'Erreur lors de la mise à jour de l\'article: Vous n\'avez pas les autorisations nécessaires';
    hideErrorMessageAfterDelay();
  } finally {
    loading2.value = false;
  }
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(headerComponent),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_unref(isUpdateRoute))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              disabled: loading2.value,
              class: "text-sm font-bold rounded-[5px] p-[10px] min-w-[100px] border border-gray-400 m-[10px] shadow-lg",
              onClick: updateArticle
            }, [
              (loading2.value)
                ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, "Mettre à jour"))
            ], 8, _hoisted_5))
          : isNewRoute
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("button", {
                  disabled: loading1.value,
                  class: "text-sm font-bold rounded-[5px] min-w-[60px] p-[10px] border border-gray-400 m-[10px] bg-cyan-800 text-white shadow-lg",
                  onClick: saveArticle
                }, [
                  (loading1.value)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, "Save"))
                ], 8, _hoisted_9),
                _createElementVNode("button", {
                  disabled: loading.value,
                  class: "text-sm font-bold rounded-[5px] p-[10px] border border-gray-400 m-[10px] bg-blue-800 text-white shadow-lg min-w-[100px]",
                  onClick: publishArticle
                }, [
                  (loading.value)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14, "Publish"))
                ], 8, _hoisted_12)
              ]))
            : _createCommentVNode("", true)
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
        class: "w-full p-[20px] outline-none text-2xl border border-gray-400 font-bold text-black",
        placeholder: "Enter article title"
      }, null, 512), [
        [_vModelText, title.value]
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("img", {
            src: viewImage.value,
            alt: ""
          }, null, 8, _hoisted_17)
        ]),
        _createElementVNode("input", {
          type: "file",
          onChange: handleImageChange,
          class: "m-[10px] max-w-[calc(100%-52%)] p-[10px]",
          placeholder: "La taille de l'image ne doit pas dépasser 2Mo"
        }, null, 32),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((source).value = $event)),
          class: "m-[10px] w-full relative p-[10px] border max-w-[calc(100%-52%)] border-gray-400 rounded-[5px] outline-none",
          placeholder: "Enter article source"
        }, null, 512), [
          [_vModelText, source.value]
        ])
      ]),
      _createVNode(_unref(QuillEditor), {
        content: content.value,
        "onUpdate:content": _cache[2] || (_cache[2] = ($event: any) => ((content).value = $event)),
        "content-type": "html",
        theme: "snow",
        toolbar: "full",
        required: "yes",
        modules: modules
      }, null, 8, ["content"])
    ]),
    _hoisted_18
  ]))
}
}

})